import {useCallback, useEffect, useState} from "react";
import {getClient} from "../API/axiosClient";

export default function useFetch(endpoint, config)
{
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const refetch = () => {
        fetch()
    }

    const fetch = useCallback(async () =>
    {
        try {
            setIsLoading(true)
            const response = await getClient().get(endpoint, config)
            setData(response.data)
        }
        catch (ex) {
            setError(ex)
        }
        finally {
            setIsLoading(false)
        }
    }, [endpoint])

    useEffect(() => {
        fetch()
    }, [endpoint, fetch])

    return { data, isLoading, error, refetch}
}